<template>
  <!-- 日期卡片 -->
  <div
    class="block__cards"
    id="block"
    @mousedown="handleMousedownBlock"
    @mouseover="handleOverBlock"
    @click="handleClickBlock"
    @click.right="floatVisible = true"
  >
    <!-- 右键菜单 and 各卡片-->
    <a-dropdown :trigger="['contextmenu']" :visible="floatVisible">
      <!-- 滚动容器 -->
      <div
        class="block__scroll"
        ref="scroll__container"
        @scroll="handleScroll"
        @mousewheel.prevent="horizontalScroll"
      >
        <!-- 卡片容器 -->
        <div
          class="block__container"
          ref="block__container"
          :class="{ nomargin }"
        >
          <!-- 卡片集合 -->
          <div
            class="block__cards"
            :style="
              `transform:translate3d(${getPixel(visibleDays[0])}px, 0, 0)`
            "
          >
            <!-- 卡片 -->
            <BlockDateCard
              v-for="day in visibleDays"
              :key="day + 'c'"
              :startTime="day"
            />
          </div>
        </div>
      </div>

      <!-- 菜单 -->
      <div
        class="float__menu"
        slot="overlay"
        @click.right.prevent
        ref="float"
        @click="floatVisible = false"
      >
        <ul class="menu__list float__list">
          <template v-if="categorys && categorys.length > 0">
            <li
              class="item"
              v-for="category in categorys"
              :key="`${category.id}rm`"
              @click.stop="setRecord({ category: category.id })"
            >
              <div class="item__title">
                <i
                  class="colorBlock"
                  :style="`background-color:${category.color};`"
                ></i>
                <span> {{ category.name }}</span>
              </div>
              <ul class="shortcut-list">
                <li
                  class="shortcut item"
                  v-for="event in getShortcut(category)"
                  :key="`${event.id}rm`"
                  @click.stop="
                    setRecord({ category: category.id, event: event.id })
                  "
                >
                  {{ event.icon }}
                  {{ event.name }}
                </li>
              </ul>
            </li>
          </template>
          <template v-else>
            <a-tooltip placement="top">
              <template slot="title">
                <span>
                  点击分类卡片上的星星可以收藏分类
                  收藏的分类会显示在右键菜单里</span
                >
              </template>
              <li class="item" @click="$router.push('/category')">
                <a-icon type="forward" style="margin-right:1rem;" />去收藏分类
              </li>
            </a-tooltip>
          </template>

          <a-divider style="margin-top:.5rem;margin-bottom:.5rem;" />

          <li class="item" @click="delRecord">
            <a-icon type="delete" style="margin-right:1rem;" />删除记录
          </li>

          <li class="item" @click="unselect">
            <a-icon type="close-square" style="margin-right:1rem;" />取消选择
          </li>
        </ul>
      </div>
    </a-dropdown>
  </div>
</template>
<script>
import BlockDateCard from "./BlockDateCard";
import { mapMutations, mapActions, mapGetters } from "vuex";
import longPress from "../mixins/longPress";
import scroll from "../mixins/scroll";

export default {
  props: ["nomargin"],
  mixins: [longPress, scroll],
  components: {
    BlockDateCard
  },
  data() {
    return {
      floatVisible: false
    };
  },
  computed: {
    categorys() {
      const result = [];
      const categorys = this.$store.getters.categorys;

      for (let key in categorys) {
        const item = categorys[key];
        //如果是收藏并且活动的

        //过滤无效的快捷方式引用
        if (item.active && item.star) {
          item.shortcut.forEach((id, index) => {
            if (!this.events[id]) item.shortcut.splice(index, 1);
          });

          result.push(item);
        }
      }
      return result;
    },
    ...mapGetters([
      "events",
      "days",
      "scrollToDay",
      "visibleDays",
      "originDate",
      "finalDate",
      "cardWidth",
      "inMul"
    ])
  },
  watch: {
    scrollToDay() {
      this.initScrollView(); //初始化滚动条位置
    }
  },
  mounted() {
    this.initDays(); //初始化范围
    this.initVisibleDays(); //初始化可视区域
    this.initScrollView(); //初始化滚动条位置
    this.initLongPress(); //初始化长按事件
  },
  methods: {
    handleOverBlock(e) {
      if (!e.target.matches(".block__block, .block__block *")) return;
      this.updatedMulInterval(parseInt(e.target.closest(".block__block").id));
    },
    handleMousedownBlock(e) {
      this.floatVisible = false;
      if (!e.target.matches(".block__block, .block__block *")) return;
      this.setMultiSelStart(parseInt(e.target.closest(".block__block").id));
    },
    handleClickBlock(e) {
      const el = e.target.closest(".block__block");
      if (!el) return;
      const time = parseInt(el.id);
      if (el.matches(".chosen")) {
        this.decSelDayByTime(time);
        this.delSelBlock(time);
      } else {
        this.incSelDayByTime(time);
        this.addSelBlock(time);
      }
    },
    getShortcut(category) {
      const result = [];
      category.shortcut.forEach(event => {
        if (this.events[event] && this.events[event].active) {
          result.push(this.events[event]);
        }
      });
      return result;
    },
    setRecord(record) {
      this.floatVisible = false;
      this.$store.dispatch("setRecord", record);
    },
    ...mapActions(["updatedMulInterval", "delRecord", "unselect"]),
    ...mapMutations([
      "initDays",
      "initVisibleDays",
      "incSelDayByTime",
      "decSelDayByTime",
      "addSelBlock",
      "delSelBlock",
      "setMultiSelStart"
    ])
  },
  beforeDestroy() {
    //删除事件绑定
    this.longPressRemoveListener();
  }
};
</script>
<style>
.block__scroll {
  height: 100%;
  width: 100%;
  margin-left: 50px;
  overflow: auto;
}
.block__cards {
  display: flex;
}

/*控制整个滚动条*/
.block__scroll::-webkit-scrollbar {
  display: none;
}

/*滚动条两端方向按钮*/
.block__scroll::-webkit-scrollbar-button {
  display: none;
}

/*滚动条中间滑动部分*/
.block__scroll::-webkit-scrollbar-thumb {
  display: none;
}

/*滚动条右下角区域*/
.block__scroll::-webkit-scrollbar-corner {
  display: none;
}
</style>
